import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import LinkWithTooltip from './tooltip';
import { Modal, ModalManager } from './index'

class PageListModal extends Component {

  constructor(props) {
    super(props);
    this.linkItems = [];
    this.buttonItems = [];

    this.state = {
      status: false,
      data: '',
      importing: false,
      activeCat: 'all',
      categories: {}
    };
  }

  componentDidMount()
  {
    jQuery.ajax({
      type: 'POST',
      url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=pre-page-list&editarea=frontend',
      dataType: 'json',
      data: {},
      processData: false,
      contentType: false,
      success: function(response) {
        if ( response.status ) {
          let cats = {}
          response.data.map(item => {
            cats[item.category] = item.category_title
          })
          this.setState({
            status: response.status,
            data: response.data,
            categories: cats
          });
        } else {
          this.setState({
            data: response.data
          });
        }
      }.bind(this)
    });
  }

  importPage( data ) {
    ModalManager.close();
    var pageData = data;
    try {
      pageData = JSON.parse(data);
    } catch (e) {}
    this.props.importPage( pageData );
  }

  getFilteredTemplates(){
    if(this.state.activeCat == 'all'){
      return this.state.data
    } else {
      let templates = []
      this.state.data.map(template => {
        if(template.category == this.state.activeCat){
          templates.push(template)
        }
      })
      return templates;
    }
  }

  render() {
    return(
      <Modal
        className="sp-pagebuilder-modal-content sp-pagebuilder-modal-pages-list"
        overlayClassName = "sp-pagebuilder-modal-overlay sp-pagebuilder-modal-overlay-after-open"
        uniqueId = "sp-pagebuilder-pagelist-modal"
        customClass = "sp-pagebuilder-big-modal"
        onRequestClose={this.props.onRequestClose}
        openTimeoutMS={0}
        title={Joomla.JText._("COM_SPPAGEBUILDER_PAGE_TEMPLATES_LIST")}
        closeTimeoutMS={0}>
        {
          this.state.status
          ?
          <div className="clearfix sppb-template-list-modal">
            <ul className="sppb-template-cats">
              <li>
                <a href="#" className={this.state.activeCat == 'all' ? 'sppb-tmpl-cat-active' : ''} onClick={e => {
                  e.preventDefault()
                  this.setState({
                    activeCat: 'all'
                  })
                }}>All Templates</a>
              </li>
              {
                _.map(this.state.categories, (category_title, category) => {
                  let active = (category == this.state.activeCat) ? 'sppb-tmpl-cat-active' : ''
                  return(
                    <li key={category}>
                      <a href="#" className={active} onClick={e => {
                        e.preventDefault()
                        this.setState({
                          activeCat: category
                        })
                      }}>{category_title}</a>
                    </li>
                  )
                })
              }
            </ul>
            <ul className="sp-pagebuilder-page-templates">
              {this.getFilteredTemplates().map( ( page,index )=>
                <li key={index}>
                  <a href="#"
                    ref={el => {
                      this.linkItems.push(el)
                    }}
                    onClick={(e) =>{

                      e.preventDefault();

                      if (this.state.importing) {
                        return;
                      }

                      this.linkItems[index].classList.add('active');
                      this.buttonItems[index].innerHTML = '<i class="fa fa-circle-o-notch fa-spin"></i>';

                      this.setState({
                        importing: true
                      })

                      var pageData = {};

                      pageData['category'] = page.category;
                      pageData['template'] = page.template;

                      jQuery.ajax({
                        type: 'POST',
                        url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=get-pre-page-data&editarea=frontend',
                        dataType: 'json',
                        data: pageData,
                        success: function(response) {
                          if ( response.status ) {
                            this.importPage(response.data);
                          } else {
                            if(jQuery('.sp-pagebuilder-notifications').length === 0) {
                  						jQuery('<div class="sp-pagebuilder-notifications"></div>').appendTo('body')
                  					}

                            jQuery('<div class="notify-error">' + response.data + '</div>').css({
                  						opacity: 0,
                  						'margin-top': -15,
                  						'margin-bottom': 0
                  					}).animate({
                  						opacity: 1,
                  						'margin-top': 0,
                  						'margin-bottom': 15
                  					},200).prependTo('.sp-pagebuilder-notifications');


                            jQuery('.sp-pagebuilder-notifications').find('>div').each(function() {
                  						var $this = jQuery(this);

                  						setTimeout(function(){
                  							$this.animate({
                  								opacity: 0,
                  								'margin-top': -15,
                  								'margin-bottom': 0
                  							}, 200, function() {
                  								$this.remove();
                  							});
                  						}, 3000);
                  					});

                            this.setState({
                              importing: false
                            });

                            this.linkItems[index].classList.remove('active');
                            this.buttonItems[index].innerHTML = '<i className="pbfont pbfont-plus"></i> '+Joomla.JText._("COM_SPPAGEBUILDER_PAGE_TEMPLATE_LOAD");
                          }
                        }.bind(this)
                      });

                    }}
                    >
                    <div>
                      <img src={`https://sppagebuilder.com/api/templates/categories/${page.category}/${page.template}/preview.jpg`} alt={page.title} />
                      {/* <span className="sppb-pro-badge">Pro</span> */}
                    </div>
                    <div className="sppb-tmpl-info">
                      <span className="sppb-tmpl-title">{page.title}</span>
                      <span className="sp-pagebuilder-btn sp-pagebuilder-btn-success" ref={el => {
                        this.buttonItems.push(el)
                      }}><i className="pbfont pbfont-plus"></i> {Joomla.JText._("COM_SPPAGEBUILDER_PAGE_TEMPLATE_LOAD")}</span>
                    </div>
                  </a>
                </li>
              )}
            </ul>
            <LinkWithTooltip tooltip={Joomla.JText._("COM_SPPAGEBUILDER_MODAL_CLOSE")} position="top" id="sp-pagebuilder-close-modal">
              <a href="#" className="sp-pagebuilder-close-modal" onClick={ e => {
                  e.preventDefault();
                  ModalManager.close()
                }}>
                <i className="fa fa-times"></i>
              </a>
            </LinkWithTooltip>
          </div>
          :
          <div>
            {
              this.state.data == ''
              ?
              <div style={{ height: "300px"}}><div className="sp-pagebuilder-loading"><i className="pbfont pbfont-pagebuilder"></i></div></div>
              :
              <h3>{this.state.data}</h3>
            }
          </div>
        }
      </Modal>
    )
  }
}

export default PageListModal;



// WEBPACK FOOTER //
// ./src/helpers/PageListModal.js